module.exports = __webpack_public_path__ + "static/img/operaingCosta.f7a8630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operaingCosta.png
// module id = Bgbq
// module chunks = 1